import React from 'react';
import colorVars from '@farmers-fridge/ui-library/dist/colors.module.css';
import Tag from './Tag';
import ChefsKnifeIcon from '../icons/ChefsKnifeIcon';

/**
 * @param {object} props
 * @param {string=} props.className
 */
export default function ChefCollabTag({ className }) {
  return (
    <Tag
      className={className}
      fillColor={colorVars.color_chrome_white}
      height={26}
      width={128}
      title="Chef Collab"
    >
      <ChefsKnifeIcon />
      <span>CHEF COLLAB</span>
    </Tag>
  );
}
